import { Badge } from '@/_shared/components/ui/badge';
import type { InteractiveStat } from '@/_shared/types';

/** A per-option number, shown as a right-aligned outline badge with tabular figures (matches the
 * header stat tags). `bg-grey-0` keeps the badge a crisp white chip on the selected row's accent tint. */
export function OptionStat({ stat }: { stat: InteractiveStat }): React.ReactElement {
  return (
    <Badge variant="outline" className="bg-grey-0 py-px tabular-nums">
      <span className="text-xs">{stat.value}</span>
      {stat.unit ? <span className="text-xs font-normal text-muted-foreground">{stat.unit}</span> : null}
    </Badge>
  );
}
